module.exports = __webpack_public_path__ + "img/Busy_Corner@2x.b3bd7523.webp";